import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    return (
        <div className="group cursor-pointer">
            {/* Image Container */}
            <div
                className="relative overflow-hidden bg-gray-100 mb-4"
                style={{ paddingBottom: '133.33%' }} // 3:4 aspect ratio
                onClick={() => navigate(`/template14/product/${product.id}`)}
            >
                <img
                    src={product.image}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />

                {/* Wishlist Button */}
                <button className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-gray-100">
                    <Heart size={18} className="text-gray-900" />
                </button>

                {/* Quick Add to Cart */}
                <button className="absolute bottom-4 left-4 right-4 bg-gray-900 text-white py-3 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-gray-800 flex items-center justify-center gap-2 text-sm font-medium">
                    <ShoppingCart size={16} />
                    Add to Cart
                </button>
            </div>

            {/* Product Info */}
            <div onClick={() => navigate(`/template14/product/${product.id}`)}>
                <h3 className="font-medium text-gray-900 mb-1 group-hover:text-gray-600 transition-colors">
                    {product.name}
                </h3>
                <p className="text-sm text-gray-600 mb-2">{product.category}</p>
                <div className="flex items-center gap-2">
                    <span className="font-semibold text-gray-900">₹{product.price}</span>
                    {product.originalPrice && (
                        <span className="text-sm text-gray-500 line-through">₹{product.originalPrice}</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
